import { queryClient } from '@api/query-client'
import type { AppRouterContext } from '@core/utils/router/create-app-root-route'
import { RouteErrorScreen } from '@design/components/screens/route-error-screen/RouteErrorScreen'
import {
  type AnyRoute,
  createRouter,
  type ParsedLocation,
} from '@tanstack/react-router'

export function createAppRouter<TRouteTree extends AnyRoute>(
  routeTree: TRouteTree,
  getScrollRestorationKey = (location: ParsedLocation) => location.pathname
) {
  const context: AppRouterContext = { queryClient }

  return createRouter({
    basepath: import.meta.env.VITE_BASE_URL || '/',
    routeTree,
    context,
    defaultErrorComponent: RouteErrorScreen,
    defaultViewTransition: true,
    scrollRestoration: true,
    getScrollRestorationKey,
  })
}
